import { Recorder } from "./Recorder";
import SocketHandler from "@/library/OraiSocketHandler";

export default class VideoRecorder implements Recorder {
  private displayElement!: HTMLVideoElement;
  private socket: SocketHandler;
  private pc!: RTCPeerConnection;
  private pcReady: Promise<void>;

  constructor(videoElement: HTMLVideoElement, socket: SocketHandler) {
    this.displayElement = videoElement;
    this.socket = socket;
    let resolvePcReady: any;
    this.pcReady = new Promise<void>((r) => (resolvePcReady = r));

    this.socket.onWebRTCMessage = (msgType: string, msg: any) => {
      if (msgType === "iceServers") {
        console.log("creating a new peer connection");
        this.pc = new RTCPeerConnection(<any>{
          sdpSemantics: "unified-plan",
          iceServers: msg.iceServers,
        });

        this.pc.onicecandidate = (event) =>
          this.socket.SendWebRTCMessage("iceCandidate", event.candidate);
        resolvePcReady();
      } else if (msgType === "sdp") {
        let parsed = new RTCSessionDescription(msg);
        this.pc
          .setRemoteDescription(parsed)
          .then(() => {
            this.pc.createAnswer().then((a) => {
              this.pc.setLocalDescription(a).then(() => {
                console.log("setup complete");
                this.socket.SendWebRTCMessage("sdp", this.pc.localDescription);
              });
            });
          })
          .catch((e) => {
            console.log(e);
            console.log(e.errorDetail);
            console.log(e.sdpLineNumber);
          });
      }
    };
  }

  public Setup(): Promise<any> {
    let p = new Promise((resolve, reject) => {
      navigator.mediaDevices
        .getUserMedia({ video: true, audio: true })
        .then((stream) => {
          if (
            stream.getVideoTracks().length === 0 ||
            stream.getAudioTracks().length === 0
          ) {
            reject();
          }
          this.displayElement.srcObject = stream;
          this.pcReady.then(() =>
            stream
              .getTracks()
              .forEach((track) => this.pc.addTrack(track, stream))
          );
          resolve();
        })
        .catch((err) => reject(err));
    });
    return p;
  }

  public StopRecording() {}

  public StartRecording() {}

  public releaseResources() {
    console.log("releasing resources");
    this.pc.getSenders().forEach((sender) => sender.track!.stop());
    this.pc.close();
  }
}
